import { Pipe, PipeTransform } from '@angular/core';
import { AuthUserDto } from '@artemis-software/wr-api';
import TenantTypeEnum = AuthUserDto.TenantTypeEnum;

@Pipe({
  standalone: false,
  name: 'tenantType',
})
export class TenantTypePipe implements PipeTransform {
  transform(value: TenantTypeEnum | undefined): string {
    if (value) {
      if (value == TenantTypeEnum.External) {
        return 'Kunde';
      } else if (value == TenantTypeEnum.Internal) {
        return 'Firma';
      } else {
        return 'Dienstleister';
      }
    }
    return 'Tenant';
  }
}
